export default class RouteFactory {
  constructor({ path, component, title, page }) {
    this.path = path;
    this.Component = component;
    this.title = title;
    this.Page = page;
  }
}